import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import {
  successfulResponsesTrns,
  pendingResponsesTrns,
  errorResponsesTrns,
} from "src/translate/responses";
import { IResponseWithPagination } from "src/@types/api";
import { IInquiry } from "src/@types/inquiries";

export const WATCHLIST_SLICE_NAME = "watchlist";
export const ITEMS_PER_PAGE = 10;

interface Params {
  filters: string;
  page?: number;
}

interface WatchlistAsyncParams {
  id: number;
  onSuccess?: () => void;
}

export const getWatchlistAsync = createAsyncThunk(
  `${WATCHLIST_SLICE_NAME}/fetchWatchlist`,
  async ({ filters = "" }: Params, { rejectWithValue }) => {
    try {
      const filtersQueryStr = filters ? filters : "page=1";

      const { data } = await instance.get<IResponseWithPagination<IInquiry>>(
        `/watchlist/?${filtersQueryStr}&page_size=${ITEMS_PER_PAGE}`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(
        errorText || errorResponsesTrns.gettingWatchlist
      );

      return rejectWithValue(errorText);
    }
  }
);

export const addToWatchlistAsync = createAsyncThunk(
  `${WATCHLIST_SLICE_NAME}/fetchAddToWatchlist`,
  async (
    { id, onSuccess = () => {} }: WatchlistAsyncParams,
    { rejectWithValue }
  ) => {
    const toastId = NotificationService.loading(
      pendingResponsesTrns.addingWatchlist
    );

    try {
      const { data } = await instance.post<IInquiry>("/watchlist/", {
        inquiry: id,
      });

      NotificationService.updateToSuccess(
        toastId,
        successfulResponsesTrns.addingWatchlist
      );

      onSuccess();

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.updateToError(
        toastId,
        errorText || errorResponsesTrns.addingWatchlist
      );

      return rejectWithValue(errorText);
    }
  }
);

export const removeFromWatchlistAsync = createAsyncThunk(
  `${WATCHLIST_SLICE_NAME}/fetchRemoveFromWatchlist`,
  async (
    { id, onSuccess = () => {} }: WatchlistAsyncParams,
    { rejectWithValue }
  ) => {
    const toastId = NotificationService.loading(
      pendingResponsesTrns.removingWatchlist
    );

    try {
      await instance.delete<IInquiry>(`/watchlist/${id}/`);

      NotificationService.updateToSuccess(
        toastId,
        successfulResponsesTrns.removingWatchlist
      );

      onSuccess();

      return id;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.updateToError(
        toastId,
        errorText || errorResponsesTrns.removingWatchlist
      );

      return rejectWithValue(errorText);
    }
  }
);
